// extracted by mini-css-extract-plugin
export var button = "_iw-2";
export var card = "_iw-0";
export var closeButtonContainer = "_iw-3";
export var iconContainer = "_iw-1";